/*@flow*/
import getCartoMap, {
  type CartoResponse,
  type VectorTileUrls,
} from 'lib/getCartoMap';
import nested from 'lib/nested';
export type { VectorTileUrls };

type Opts =
  | string
  | {
      sql: string,
      userName?: string,
      apiKey?: string,
    };

export const extractVectorTiles = (res: CartoResponse): VectorTileUrls =>
  nested('metadata.tilejson.vector.tiles', [])(res);

export default (opts: Opts): Promise<VectorTileUrls> => {
  let sql;
  let userName = '';
  let apiKey = '';

  if (typeof opts === 'string') {
    sql = opts;
  } else if (typeof opts === 'object') {
    sql = opts.sql;
    apiKey = opts.apiKey || '';
    userName = opts.userName || '';
  }

  const config = {
    layers: [
      {
        type: 'cartodb',
        options: {
          sql,
        },
      },
    ],
  };

  const requestOpts = {
    params: {
      userName,
      apiKey,
    },
  };

  return getCartoMap(config, requestOpts).then(extractVectorTiles);
};
